import {connect} from 'react-redux';
import OurAdvantage from '../components/our-advantage';

const mapStateToProps = (state) => {
  return {entity: state.store.entity};
};

export default connect(mapStateToProps)(OurAdvantage);



// WEBPACK FOOTER //
// ./src/containers/our-advantage.js